// extracted by mini-css-extract-plugin
module.exports = {"header":"Modal_header__VcvCN","content":"Modal_content__BaPv5","footer":"Modal_footer__1lpLO","loader":"Modal_loader__wa0kq"};